import './styles/default.scss';
import { ImageComponent } from '../image-component/image-component';

export type ImageTextProps = {
    src: string;
    alt: string;
    width: number;
    height: number;
    text: string;
    useNext?: boolean;
};

export const ImageText = ({ src, alt, width, height, text, useNext = false }: ImageTextProps) => {
    return (
        <>
            <ImageComponent src={src} alt={alt} width={width} height={height} useNext={useNext} />
            <span className="image-text__span">{text}</span>
        </>
    );
};
